import { ComponentProps, CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';
import expressablesLg from 'assets/images/expressables-footer-lg.png';
import expressablesMd from 'assets/images/expressables-footer-md.png';
import expressablesSm from 'assets/images/expressables-footer-sm.png';
import { BasicLayout } from 'components/Layout/BasicLayout';
import { FlashWrapper } from 'components/FlashMessages';
import { FormPageLayout } from '@expressable/syntax-ds';

type Props = ComponentProps<typeof BasicLayout>;

export const AuthenticationLayout = ({ children = <Outlet />, ...rest }: Props): JSX.Element => {
  return (
    <BasicLayout {...rest}>
      <FormPageLayout variant="full" className="flex flex-col gap-e40 mb-e80 items-center max-w-[600px]">
        <FlashWrapper className="mb-40 md:mb-64 w-full max-w-[600px]" />

        {children}
      </FormPageLayout>

      <ExpressablesFooter />
    </BasicLayout>
  );
};

type ExpressablesFooterProps = {
  style?: CSSProperties;
};

export const ExpressablesFooter = ({ style }: ExpressablesFooterProps) => (
  <footer className="flex flex-col flex-grow justify-end" style={style}>
    <img alt="" className="h-auto w-full hidden xl:block" src={expressablesLg} />
    <img alt="" className="h-auto w-full hidden sm:block xl:hidden" src={expressablesMd} />
    <img alt="" className="h-auto w-full sm:hidden" src={expressablesSm} />
  </footer>
);
